// import faker from "faker";
import {randomColor} from "./utils";

export default function makeData(datos,tipo) {
  let optionss = [
    {label: 'pickup', backgroundColor: '#fc0127'},
    {label: 'shipment', backgroundColor: '#f4a020'},
    {label: 'delivery', backgroundColor: '#B0FC38'}
  ];
 
  let columns
  (tipo==='performance')
  ?columns = [
    {
      id: "distance_total_km",
      label: "Total distance (km)",
      accessor: "distance_total_km",
      width: 100,
      dataType: "number",
      options: []
    },
    {
      id: "cost_total_eur",
      label: "Total cost (€)",
      accessor: "cost_total_eur",
      width: 100,
      dataType: "number",
      options: []
    },
    {
      id: "cost_activation_eur",
      label: "Activation cost (€)",
      accessor: "cost_activation_eur",
      width: 100,
      dataType: "number",
      options: []
    },
    {
      id: "cost_time_eur",
      label: "Time cost (€)",
      accessor: "cost_time_eur",
      width: 100,
      dataType: "number",
      options: []
    },
    {
      id: "cost_distance_eur",
      label: "Distance cost (€)",
      accessor: "cost_distance_eur",
      dataType: "number",
      width: 100,
      options: []
    },
    {
      id: "emissions_kgco2",
      label: "Emissions (kg CO2)",
      accessor: "emissions_kgco2",
      dataType: "number",
      width: 100,
      options: []
    },
    {
      id: "orders_total",
      label: "Total orders",
      accessor: "orders_total",
      dataType: "number",
      width: 100,
      options: []
    },
    {
      id: "orders_completed",
      label: "Orders completed",
      accessor: "orders_completed",
      dataType: "number",
      width: 100,
      options: []
    },
    {
      id: "orders_completedontime",
      label: "Orders completed on time",
      accessor: "orders_completedontime",
      dataType: "number",
      width: 100,
      options: []
    },
    					
    {
      id: "orders_avgleadtime_min",
      label: "Orders Average lead time (min)",
      accessor: "orders_avgleadtime_min",
      dataType: "number",
      width: 100,
      options: []
    },
    {
      id: "tours_avgdistance_km",
      label: "Average distance tours (km)",
      accessor: "tours_avgdistance_km",
      dataType: "number",
      width: 100,
      options: []
    },
    {
      id: "tours_avgtime_min",
      label: "Average time tours (min)",
      accessor: "tours_avgtime_min",
      dataType: "number",
      width: 100,
      options: []
    },
    									
  ]
  :(tipo==='tours')							
    ?columns=[
        {
          id: "tour_id",
          label: "Id tour",
          accessor: "tour_id",
          width: 50,
          dataType: "number",
          options: []
        },
        {
          id: "tour_idtransptype",
          label: "Id vehicle tour",
          accessor: "tour_idtransptype",
          width: 100,
          dataType: "number",
          options: []
        },
        {
          id: "tour_departuretime",
          label: "Start time",
          accessor: "tour_departuretime",
          width: 80,
          dataType: "number",
          options: []
        },
        {
          id: "tour_end_timestamp",
          label: "End time",
          accessor: "tour_end_timestamp",
          width: 80,
          dataType: "number",
          options: []
        },
      ]
    :(tipo==='tours_out')
      ?columns=[
          {
            id: "tour_id",
            label: "Id tour",
            accessor: "tour_id",
            width: 40,
            dataType: "number",
            options: []
          },
          {
            id: "transptype_name",
            label: "Vehicle name",
            accessor: "transptype_name",
            width: 80,
            dataType: "text",
            options: []
          },
          {
            id: "hub_name",
            label: "Hub name",
            accessor: "hub_name",
            width: 70,
            dataType: "text",
            options: []
          },
          {
            id: "transp_distance_km",
            label: "Distance (km)",
            accessor: "transp_distance_km",
            width: 80,
            dataType: "number",
            options: []
          },
          {
            id: "transp_totaltime_min",
            label: "Time (min)",
            accessor: "transp_totaltime_min",
            width: 70,
            dataType: "number",
            options: []
          },
          {
            id: "transp_totalcost_eur",
            label: "Cost (€)",
            accessor: "transp_totalcost_eur",
            width: 70,
            dataType: "number",
            options: []
          },
          {
            id: "transp_emissions_kgco2",
            label: "Emissions (kg CO2)",
            accessor: "transp_emissions_kgco2",
            width: 100,
            dataType: "number",
            options: []
          },
          {
            id: "transp_avgfillrate_percentage",
            label: "Vehicle average fill rate (%)",
            accessor: "transp_avgfillrate_percentage",
            width: 130,
            dataType: "number",
            options: []
          },
          {
            id: "transptype_capacityweight",
            label: "Vehicle capacity (kg)",
            accessor: "transptype_capacityweight",
            width: 120,
            dataType: "number",
            options: []
          },									
          {
            id: "transptype_capacityitems",
            label: "Vehicle capacity (items)",
            accessor: "transptype_capacityitems",
            width: 120,
            dataType: "number",
            options: []
          },
        ]
      :(tipo==='orderNoManaged')
        ?columns=[
          {
            id: "order_id",
            label: "Id",
            accessor: "order_id",
            width: 20,
            dataType: "number",
            options: []
          },
          {
            id: "order_name",
            label: "Name",
            accessor: "order_name",
            width: 100,
            dataType: "text",
            options: []
          },
          {
            id: "order_mode",
            label: "Mode",
            accessor: "order_mode",
            width: 100,
            dataType: "select",
            options: optionss
          },
          {
            id: "order_idhub",
            label: "Hub id",
            accessor: "order_idhub",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_lat1",
            label: "Latitude 1",
            accessor: "order_lat1",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_lon1",
            label: "Longitude 1",
            accessor: "order_lon1",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_earlytime1",
            label: "Early Time 1",
            accessor: "order_earlytime1",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_latetime1",
            label: "Late Time 1",
            accessor: "order_latetime1",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_servicetime1",
            label: "Service Time 1",
            accessor: "order_servicetime1",
            width: 120,
            dataType: "number",
            options: []
          },									
          {
            id: "order_items",
            label: "Items",
            accessor: "order_items",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_weight",
            label: "Weight",
            accessor: "order_weight",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_pc",
            label: "Postal Code",
            accessor: "order_pc",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_lat2",
            label: "Latitude 2",
            accessor: "order_lat2",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_lon2",
            label: "Longitude",
            accessor: "order_lon2",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_earlytime2",
            label: "Early Time 2",
            accessor: "order_earlytime2",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_latetime2",
            label: "Late Time 2",
            accessor: "order_latetime2",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_servicetime2",
            label: "Service Time 2",
            accessor: "order_servicetime2",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_bolactivo",
            label: "Active",
            accessor: "order_bolactivo",
            width: 100,
            dataType: "number",
            options: []
          },
          {
            id: "order_revenue",
            label: "Revenue",
            accessor: "order_revenue",
            width: 100,
            dataType: "number",
            options: []
          },
        ]
        :columns={}

  // console.log(columns,'columns')
  return {columns: columns, data: datos, skipReset: false};
}

// export default function makeData(count) {
//   let data = [];
//   let options = [];
//   for (let i = 0; i < count; i++) {
//     let row = {
//       ID: faker.mersenne.rand(),
//       firstName: faker.name.firstName(),
//       lastName: faker.name.lastName(),
//       email: faker.internet.email(),
//       age: Math.floor(20 + Math.random() * 20),
//       music: faker.music.genre()
//     };
//     options.push({label: row.music, backgroundColor: randomColor()});

//     data.push(row);
//   }

//   let columns = [
//     {
//       id: "firstName",
//       label: "First Name",
//       accessor: "firstName",
//       minWidth: 100,
//       dataType: "text",
//       options: []
//     },
//     {
//       id: "lastName",
//       label: "Last Name",
//       accessor: "lastName",
//       minWidth: 100,
//       dataType: "text",
//       options: []
//     },
//     {
//       id: "age",
//       label: "Age",
//       accessor: "age",
//       width: 80,
//       dataType: "number",
//       options: []
//     },
//     {
//       id: "email",
//       label: "E-Mail",
//       accessor: "email",
//       width: 300,
//       dataType: "text",
//       options: []
//     },
//     {
//       id: "music",
//       label: "Music Preference",
//       accessor: "music",
//       dataType: "select",
//       width: 200,
//       options: options
//     },
//     {
//       id: 999999,
//       width: 20,
//       label: "+",
//       disableResizing: true,
//       dataType: "null"
//     }
//   ];
//   return {columns: columns, data: data, skipReset: false};
// }
